export default __webpack_public_path__ + "static/media/png-dropdown.5d49b949.webp";